import { useTranslation } from "react-i18next"
import { Check, Rocket } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

type UpgradeModalProps = {
  open: boolean
  onClose: () => void
  onUpgrade: () => void
  /** What the user was doing when the limit was hit (i18n key or short label). */
  feature: string
}

export function UpgradeModal({ open, onClose, onUpgrade, feature }: UpgradeModalProps) {
  const { t } = useTranslation()

  function handleViewPlans() {
    onClose()
    onUpgrade()
  }

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md gap-0 border-border p-0 sm:max-w-md">
        <div className="p-6 pb-4">
          <DialogHeader className="text-left">
            <DialogTitle className="flex items-center gap-2 text-base font-semibold sm:text-lg">
              <Rocket className="size-5 shrink-0 text-primary" aria-hidden />
              {t("upgrade.title")}
            </DialogTitle>
            <DialogDescription className="sr-only">{t("upgrade.title")}</DialogDescription>
            <div className="space-y-1 pt-2 text-sm text-muted-foreground">
              <p>{feature || t("upgrade.subtitle")}</p>
              <p className="font-medium text-foreground">{t("upgrade.proIncludes")}</p>
              <ul className="ml-0 list-none space-y-1.5 pl-0 text-sm text-muted-foreground">
                <li className="flex items-center gap-2">
                  <Check className="size-4 shrink-0 text-primary" aria-hidden />
                  {t("upgrade.bulletWorkspaces")}
                </li>
                <li className="flex items-center gap-2">
                  <Check className="size-4 shrink-0 text-primary" aria-hidden />
                  {t("upgrade.bulletTasks")}
                </li>
                <li className="flex items-center gap-2">
                  <Check className="size-4 shrink-0 text-primary" aria-hidden />
                  {t("upgrade.bulletExtraction")}
                </li>
                <li className="flex items-center gap-2">
                  <Check className="size-4 shrink-0 text-primary" aria-hidden />
                  {t("upgrade.bulletEmail")}
                </li>
                <li className="flex items-center gap-2">
                  <Check className="size-4 shrink-0 text-primary" aria-hidden />
                  {t("upgrade.bulletSupport")}
                </li>
              </ul>
              <p className="pt-1 text-foreground">{t("upgrade.price")}</p>
            </div>
          </DialogHeader>
        </div>
        <div className="flex flex-col-reverse gap-2 border-t border-border bg-muted/30 p-4 sm:flex-row sm:justify-end">
          <Button type="button" variant="ghost" onClick={onClose}>
            {t("upgrade.notNow")}
          </Button>
          <Button type="button" onClick={handleViewPlans}>
            {t("upgrade.viewPlans")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
